import { render } from "./SellerDetailsPage.vue?vue&type=template&id=7765ae60&ts=true"
import script from "./SellerDetailsPage.vue?vue&type=script&lang=ts"
export * from "./SellerDetailsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__